import { useTheme } from '@telescope/cassini-hooks';
import { Box, Button, useColorModeValue } from '@telescope/cassini-ui';
import { Text } from 'components';
import { useBingo } from '../providers';
import { Tile as TileData } from '../types';

export const Tile = ({ data, row, column } : { data: TileData, row: number, column: number }) => {
  const theme = useTheme();
  const { defaultColorScheme: c } = theme.settings;

  const { toggleTile, selections } = useBingo();
  const selected = selections[row][column] === 1;

  const color = useColorModeValue(`${c}.900`, `${c}.50`);
  const hover = useColorModeValue(`${c}.400`, `${c}.600`);
  

  return (
    <Button onClick={() => toggleTile(row, column)} aria-pressed={selected} 
            borderRadius={0} w="100%" h="100%" overflow="hidden" p={0}
            bg={selected? color : `${c}.500`}
            color={selected? `${c}.500` : color}
            _hover={selected? {} : {
              bg: hover
            }}>

      { data.image ? 
        <Box position="absolute" w="100%" h="100%" top="0" left="0" opacity={selected? 0.5 : 1}
              bgImage={data.image} bgSize="cover" bgPosition="center"/> :
        <Text fontSize={data.text ? {base: '0.5rem', xs: '2xs', sm: 'xs', md: 'sm'} : {base: '4xl', lg: '5xl'}} 
              fontWeight="800" whiteSpace="break-spaces" maxW="100%" p="5px"
              allowMarkdown>
          {`${data.text || data.number}`}
        </Text> } 
    </Button>
  )
}